<nb-tabset>
  <nb-tab tabTitle="Asociacion" tabIcon="upload-outline" responsive
    [ngClass]="showSpinnerIcono === true ? 'cursor': 'asociacionContainer'">
    <div cdkDropListGroup class="listContainer">
      <div class="example-container">
        <div class="row">
          <div>
            <h2 style="margin-left: 20px" [hidden]="showSpinnerIcono">Operadores</h2>
          </div>
          <div>
            <button nbButton shape="round" size="small float-right" class="btn-ayuda" (click)="openDialog()"
              [hidden]="showSpinnerIcono">
              <nb-icon nbPrefix icon="question-mark-circle-outline"></nb-icon>
            </button>
          </div>
        </div>
        <app-spinner *ngIf="showSpinnerOperadores"></app-spinner>
        <div *ngIf="!showSpinnerOperadores" id="operadores" [hidden]="showSpinnerIcono" cdkDropList
          [cdkDropListData]="operadores" class="example-list" cdkDropListSortingDisabled
          (cdkDropListDropped)="drop($event)">
          <div class="example-box" *ngFor="let item of operadores" cdkDrag>{{item.name}}</div>
        </div>
      </div>
      <app-spinner *ngIf="showSpinnerIcono"></app-spinner>
      <button nbButton shape="round" size="giant" class="iconflechas" disabled *ngIf="!showSpinnerIcono">
        <nb-icon nbPrefix icon="swap-outline" style="color: gray; width: 50px; height: 50px;"></nb-icon>
      </button>
      <div class="example-container">
        <h2 [hidden]="showSpinnerIcono">Mis Operadores</h2>
        <app-spinner *ngIf="showSpinnerMisOperadores"></app-spinner>
        <div *ngIf="!showSpinnerMisOperadores" id="misOperadores" [hidden]="showSpinnerIcono" cdkDropList
          [cdkDropListData]="misOperadores" class="example-list" cdkDropListSortingDisabled
          (cdkDropListDropped)="drop($event)">
          <div class="example-box" *ngFor="let item of misOperadores" cdkDrag>{{item.name}}</div>
        </div>
      </div>
      <!-- <app-spinner *ngIf=""></app-spinner> -->
      <!-- <button nbButton shape="round" size="small" class="buttontz float-right" style="margin-bottom: 10px;" (click)="getOperadores()">
              <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
            </button> -->
    </div>
  </nb-tab>
</nb-tabset>